import { AxiosRequestConfig } from 'axios'
import { get_csrf } from 'API/definitions/iris/authentication'

let csrf_token;
const UNSAFE_METHODS = ['post', 'put', 'patch', 'delete']

async function getCsrfToken(): Promise<string | null> {
  try {
    const csrftoken_response  = await get_csrf()
    return csrftoken_response['csrftoken']
  } catch (error) {
    console.error('Error fetching CSRF token:', error);
    return null;
  }
}

async function csrfInterceptor(config: AxiosRequestConfig): Promise<AxiosRequestConfig> {
    // Check if the request is an "unsafe" request
    if (UNSAFE_METHODS.includes(config.method?.toLowerCase())) {
      if (!csrf_token) {
        // Obtain CSRF token from the backend endpoint
        csrf_token = await getCsrfToken();
      }

      // Attach CSRF token to the api client headers
      config.headers['X-CSRFToken'] = csrf_token;
    }

  return config
}

export { csrfInterceptor }
